import React, { useMemo } from "react";
import webui from "@tinqin/tinqin-web-ui";
import { xssFilter } from "../../../common/utils/xssFilter";
import { IComponentProps, IExtractedProps, SirenEntity } from "../../../common/utils/commonTypes";

export const CallToActionSection: React.FC<IComponentProps> = props => {
    const onClick = () => {
        webui.getUtils().dispatchSirenActions(["default", "click"]);
    };

    const data: SirenEntity["properties"] = props.data ? props.data.properties || {} : null;

    const dataProps: IExtractedProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["label", "anchorId", "description"]
    });

    const descriptionHTML: string = useMemo(() => xssFilter.process(dataProps.description), [
        dataProps.description
    ]);

    if (!data) {
        return null;
    }

    return (
        <div className="tq-flex-container tq-flex-item-l-1 un-cp-accent-box">
            <div className="tq-flex-item un-cp-accent-btn-box">
                <button
                    className="tq-button tq-icon un-button-blue"
                    onClick={onClick}
                    id={dataProps.anchorId ? dataProps.anchorId : null}
                >
                    <span className="tq-text-node">{dataProps.label}</span>
                </button>
            </div>
            {dataProps.description && (
                <div
                    className="tq-flex-item un-cp-accent-p"
                    dangerouslySetInnerHTML={{
                        __html: descriptionHTML
                    }}
                ></div>
            )}
        </div>
    );
};

export default webui.connectComponent({
    actions: { dispatchSirenActions: "siren.dispatchSirenActions" }
})(CallToActionSection);
